<hr><button type="button" class="btn btn-info btn-block" (click)="openNewDialog()"
    *ngIf="this.modalType === 'event-add'"><i class="fas fa-plus"></i> Add Event</button>